export const engagementAsyncSegmentInsightsStatsAppGroupIdCacheKey =
  "/engagement/async/segment_insights_stats/:app_group_id" as const;
